/**
 * Beem — Notification chime.
 * Web Audio API. No file, no network. Two-note soft rise (E5 -> A5) with a
 * short envelope. Persistent user preference in localStorage.
 */

const KEY = "beem-notif-sound";

export function isSoundEnabled() {
  const v = localStorage.getItem(KEY);
  // default: enabled
  return v === null ? true : v === "1";
}

export function setSoundEnabled(v) {
  localStorage.setItem(KEY, v ? "1" : "0");
}

let _ctx = null;
function ctx() {
  if (!_ctx) {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return null;
    _ctx = new AC();
  }
  // Resume if the browser suspended it (autoplay policies)
  if (_ctx.state === "suspended") _ctx.resume().catch(() => {});
  return _ctx;
}

/**
 * Plays a soft two-note chime.
 * @param {"chime"|"success"|"attention"} kind
 */
export function playNotifSound(kind = "chime") {
  if (!isSoundEnabled()) return;
  const ac = ctx();
  if (!ac) return;

  const notes =
    kind === "success"
      ? [659.25, 987.77]           // E5 → B5
      : kind === "attention"
      ? [880.0, 587.33, 880.0]     // A5 → D5 → A5 (small doorbell)
      : [659.25, 880.0];           // chime: E5 → A5 (default)

  const t0 = ac.currentTime + 0.02;
  const step = 0.14;
  const gainMaster = ac.createGain();
  gainMaster.gain.value = 0.0;
  gainMaster.connect(ac.destination);

  notes.forEach((freq, i) => {
    const osc = ac.createOscillator();
    const g = ac.createGain();
    osc.type = "sine";
    osc.frequency.value = freq;

    const start = t0 + i * step;
    const attack = 0.008;
    const release = 0.18;
    // Envelope
    g.gain.setValueAtTime(0.0, start);
    g.gain.linearRampToValueAtTime(0.18, start + attack);
    g.gain.exponentialRampToValueAtTime(0.0001, start + attack + release);

    osc.connect(g).connect(gainMaster);
    osc.start(start);
    osc.stop(start + attack + release + 0.02);
  });

  // Master fade for softness
  gainMaster.gain.setValueAtTime(0.0, t0);
  gainMaster.gain.linearRampToValueAtTime(1.0, t0 + 0.02);
  gainMaster.gain.linearRampToValueAtTime(0.0, t0 + notes.length * step + 0.22);
}
